import { useState } from "react";
import { Plus } from "lucide-react";
import { Chip } from "@/components/kit";

export const slug = (s) => s.toLowerCase().replace(/[^a-z0-9]+/g, "-");
export const toggleIn = (list, v) => (list.includes(v) ? list.filter((x) => x !== v) : [...list, v]);

export const ChipGroup = ({ title, items, selected, onChange, prefix, onAdd }) => {
  const [txt, setTxt] = useState("");
  const add = () => {
    const v = txt.trim();
    if (!v) return;
    if (!selected.includes(v)) onChange([...selected, v]);
    onAdd?.(v);
    setTxt("");
  };
  const extras = selected.filter((s) => !items.some((i) => i.label === s));
  return (
    <div className="mb-8">
      <h3 className="font-semibold mb-3">{title}</h3>
      <div className="flex flex-wrap gap-2">
        {items.map((i) => (
          <Chip key={i.label} on={selected.includes(i.label)} onClick={() => onChange(toggleIn(selected, i.label))} testId={`${prefix}-chip-${slug(i.label)}`}>
            <span>{i.icon}</span>{i.label}
          </Chip>
        ))}
        {extras.map((s) => (
          <Chip key={s} on onClick={() => onChange(toggleIn(selected, s))} testId={`${prefix}-chip-custom-${slug(s)}`}>✨ {s}</Chip>
        ))}
      </div>
      <div className="flex gap-2 mt-3 max-w-md">
        <input className="mm-input !py-2" placeholder="+ Add your own" value={txt} onChange={(e) => setTxt(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && (e.preventDefault(), add())} data-testid={`${prefix}-custom-input`} />
        <button type="button" className="mm-btn-ghost !px-4" onClick={add} data-testid={`${prefix}-custom-add`}><Plus size={16} /></button>
      </div>
    </div>
  );
};
